<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '보수일' },
        { type: 'text', label: '점검장소' },
      ]"
      :board="this.board"
      :is-print="isPrint"
      @selectField="onSelectFieldSelector"
    />

    <!-- 사업장 개요 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 사업장 개요</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>사업장명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else v-model="form.inputA_1" readonly />
        </div>
        <div>
          <div>담당 주무관</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" readonly />
        </div>
        <div class="hidden xl:block"></div>
        <div>
          <div>사업기간</div>
          <p v-if="isPrint" class="print-input">{{ `${form.inputA_3}~${form.inputA_4}` }}</p>
          <div v-else class="time">
            <date-selector v-model="form.inputA_3" readonly />
            ~
            <date-selector v-model="form.inputA_4" readonly />
          </div>
        </div>
        <div>
          <div>사업금액</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <ml-input v-else v-model="form.inputA_5" readonly />
        </div>
        <div>
          <div>시설물 위치(주소)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>
          <ml-input v-else v-model="form.inputA_6" readonly />
        </div>
      </div>
    </div>

    <!-- 개선 계획 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 개선 계획</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>재해형태</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <DisasterClassSelector multiple :addData="['직접입력']" v-model="form.inputB_1" />
        </div>
        <div v-show="form.inputB_1.includes('직접입력')">
          <div>직접입력</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input v-else v-model="form.inputB_2" />
        </div>
      </div>
      <div class="writeGridContainer mt-4">
        <div>
          <div>주체</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <multiselect v-else :options="multiselectList2" v-model="form.inputB_3" multiple placeholder="" />
        </div>
        <div v-show="form.inputB_3.includes('직접입력')">
          <div>직접입력</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input v-else v-model="form.inputB_4" />
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import Multiselect from "vue-multiselect";
import { disasters } from "@/util/DisasterDataUtil.js";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";

export default {
  components: {
    FileUploadModule,
    DateSelector,
    FieldSelectModule,
    PhotoUploadGridModule,
    Multiselect,
    DisasterClassSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",

        fileList: [],
      },
      multiselectList1: [...disasters, "직접입력"],
      multiselectList2: ["직접", "도급", "용역", "위탁", "기타", "직접입력"],
    };
  },
  methods: {
    onSelectFieldSelector(value) {
      this.form.inputA_1 = value.field_name; // 사업장 개요
      this.form.inputA_2 = value.manager_name; // 담당 주무관
      this.form.inputA_3 = value.start_work_at; // 사업기간 시작
      this.form.inputA_4 = value.be_completed_at; // 사업기간 종료
      this.form.inputA_5 = value.deposit_amount; // 계약금액
      this.form.inputA_6 = value.address; // 시설물 위치
    },
  },
};
</script>
